// ----------------- START PURCHASE SCRIPT ------------------------------------

// `breeze-purchase` event listener
window.addEventListener("breeze-purchase", (event) => {
  const eventData = event.detail;
  breezePurchase(eventData);
});

// This function will be invoked by breeze after purchase
function breezePurchase(payload) {
  try {
    merchantPurchaseCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants purchase script : ", e);
  }
}

// merchant script for `purchase` will be pasted here
function merchantPurchaseCustomCode(params) {

  // GOOGLE ADS PURCHASE EVENT CODE START
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "AW-721949903");
  window.gtag("event", "purchase", {
    send_to: ["AW-721949903"],
    value: params.totalPrice,
    currency: "INR",
    transaction_id: params.shopOrderId,
  });
  // GOOGLE ADS PURCHASE EVENT CODE END
  
}

// ----------------- END PURCHASE SCRIPT --------------------------------------